export const REGEX_POSITIVE_NUMBER = /^[0-9]+$/;
export const REGEX_POSITIVE_DECIMAL = /^[0-9.]+$/;
export const REGEX_NUMBER = /^[0-9-]+$/;
export const REGEX_DECIMAL = /^[0-9.-]+$/;
export const REGEX_COMMA_SEPARATED_NUMBER = /^([0-9]+,)+[0-9]+$/;
export const REGEX_COMMA_SEPARATED_DECIMAL = /^([0-9.]+,)+[0-9.]+$/;
export const REGEX_SHORTAGE_EXCESS = /^(([0-9.]+[r|R]*)+,)*([0-9.]+[r|R]*)+$/;
export const REGEX_ROLL_SPLITTING = /^(([0-9.]+[d|D|w|W|r|R]*)+,)*([0-9.]+[d|D|w|W|r|R]*)+$/;
export const REGEX_SPLICE_POINT = /^\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\s*$/;

export const REGEX_USERNAME = /^[a-zA-Z]+[a-zA-Z0-9_.-]*$/;
export const REGEX_EMAIL = /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,15}$/;
export const REGEX_MOBILE = /^[1-9]{1}[0-9]{9}$/;

/* eslint-disable-next-line */
export const REGEX_COLOR = /^[a-zA-Z0-9 !"#$%'()*+.:;<>?@^\[\]\\_`{|}~-]*$/;

export const REGEX_REPEAT = /^\s*\d+(\.\d{1,2})?\s*((X|x)\s*\d+(\.\d{1,2})?\s*)?$/;
export const REGEX_SHRINKAGE = /^\s*L(-|\+)?\d+(\.\d{1,2})?%\s+W(-|\+)?\d+(\.\d{1,2})?%\s*$/;
export const REGEX_COMMA_OR_SEMICOLON = /[,;]/;
